import {
  InvalidateQueryFilters,
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { MEDIAS_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ErrorDTO, SimpleResponseDTO } from "interface";
import { mediaDeleteType } from "../type";

type QueryOptionsWithoutMutationFn = Omit<
  UseMutationOptions<
    SimpleResponseDTO<number>,
    AxiosError<ErrorDTO>,
    mediaDeleteType,
    unknown
  >,
  "mutationFn"
>;

export const useDeleteMedia = (options?: QueryOptionsWithoutMutationFn) => {
  const queryClient = useQueryClient();

  return useMutation<
    SimpleResponseDTO<number>,
    AxiosError<ErrorDTO>,
    mediaDeleteType
  >({
    retry: 0,
    ...options,
    mutationFn: async (data: mediaDeleteType) => {
      const result = await instance.delete<SimpleResponseDTO<number>>(
        `${MEDIAS_END_POINTS.delete}?id=${data.id}`
      );

      return result.data;
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries([
        MEDIAS_END_POINTS.grid,
      ] as InvalidateQueryFilters);
      toast.success(`آیتم با موفقیت حذف گردید`);
    },
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data?.Message || "خطا در حذف آیتم"}`);
    },
  });
};
